import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from '@mui/material';

export default function Select({
  name,
  width = '100%',
  disabled = false,
  required,
  nullable,
  label,
  options = [],
  value: controlledValue,
  defaultValue = '',
  onChange,
  error = undefined,
  size = 'medium',
}) {
  const intl = useIntl();
  const selectId = `${name}-select`;
  const labelId = `${name}-select-label`;
  const isControlled = controlledValue !== undefined;
  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);

  useEffect(() => {
    if (!isControlled) {
      setUncontrolledValue(defaultValue ?? '');
    }
  }, [defaultValue, isControlled]);

  const value = isControlled
    ? (controlledValue ?? '')
    : (uncontrolledValue ?? '');

  const handleChange = (event) => {
    if (!isControlled) {
      setUncontrolledValue(event.target.value);
    }

    if (onChange) onChange(event.target.value);
  };

  return (
    <FormControl
      id={`${name}-form-control`}
      fullWidth={width === '100%'}
      sx={{ width }}
      disabled={disabled}
      required={required}
      error={error}
      size={size}
      onClick={(e) => {
        // Stop event propagation to prevent unwanted side effects (e.g., closing dropdowns)
        e.stopPropagation();
      }}
    >
      {label && (
        <InputLabel id={labelId}>
          {intl.messages[label?.toUpperCase()] || label}
        </InputLabel>
      )}
      <MuiSelect
        id={selectId}
        labelId={label ? labelId : undefined}
        name={name}
        label={label ? intl.messages[label?.toUpperCase()] || label : ''}
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled}
      >
        {options.length === 0 && (
          <MenuItem disabled>
            {intl.messages.NO_OPTIONS || 'No options available'}
          </MenuItem>
        )}
        {nullable && options.length > 0 && <MenuItem value={''}>---</MenuItem>}
        {options.map((option) =>
          typeof option === 'string' ? (
            <MenuItem key={option} value={option}>
              {intl.messages[option?.toUpperCase()] || option}
            </MenuItem>
          ) : (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option?.disabled}
            >
              {intl.messages[option.label?.toUpperCase()] || option.label}
            </MenuItem>
          )
        )}
      </MuiSelect>
    </FormControl>
  );
}
